import { createTheme } from '@mui/material/styles';

export const poolAppyTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#006fc9', dark: '#0059a3', contrastText: '#ffffff' },
    secondary: { main: '#18cbd1' },
    background: { default: '#ffffff', paper: '#ffffff' },
    text: { primary: '#242424', secondary: '#605e5c' },
    divider: '#edebe9',
  },
  shape: { borderRadius: 4 },
  typography: {
    fontFamily: '"Segoe UI", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    fontSize: 14,
    h1: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.3 },
    h2: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.35 },
    button: { textTransform: 'none', fontWeight: 400 },
  },
  components: {
    MuiAppBar: { styleOverrides: { root: { backgroundColor: '#002050' } } },
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
  },
});
